import Icon from '@ant-design/icons'
import React from 'react'
import Radar from './radar'

const RadarIcon = (props) => <Icon component={Radar(props)} {...props} />

export default RadarIcon
